import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          Raspberry Pi Dashboard
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/database" className="nav-link">
              Database
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/authentication" className="nav-link">
              Authentication
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;